/**
 * Global reminder fields configuration
 * THIS PACKAGE SHOULD HAVE NO DEPENDENCIES
 */

export enum PostFields {
  MUSIC = 'music',
  TITLE = 'title',
  TEXT = 'text',
  TOPICS = 'topics',
  PRODUCTS = 'products',
  OTHER = 'other',
  LINK = 'link',
  FIRST_COMMENT = 'comment_text',
  LOCATION_NAME = 'service_geolocation_name',
  LOCATION_ID = 'service_geolocation_id',
  COLLABORATORS = 'collaborators',
  TRIAL_REEL_GRADUATION_STRATEGY = 'trial_reel_graduation_strategy',
  SHARE_TO_FEED = 'share_to_feed',
  IS_AI_GENERATED = 'is_ai_generated',
}

enum UpdateService {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Pinterest = 'pinterest',
  Twitter = 'twitter',
  Tiktok = 'tiktok',
  GoogleBusiness = 'googlebusiness',
  StartPage = 'startPage',
  Mastodon = 'mastodon',
  Youtube = 'youtube',
  Threads = 'threads',
}

enum UpdateType {
  WHATS_NEW = 'whats_new',
  OFFER = 'offer',
  EVENT = 'event',
  POST = 'post',
  REELS = 'reels',
  THREAD = 'thread',
  STORY = 'story',
  SHORT = 'short',
  VIDEO = 'video',
  FACEBOOK_REEL = 'facebook_reel',
  CAROUSEL = 'carousel',
  GHOST_POST = 'ghost_post',
}

export type Settings = {
  reminderFields: PostFields[]
  postFields: PostFields[]
}

export type PostTypeConfig = {
  [key: string]: Settings & { remindersEnabled?: boolean }
}

type ServiceDetail = {
  enabled: boolean
  postTypes: PostTypeConfig
}

type ServiceConfig = Record<string, ServiceDetail>

export const ChannelFieldConfiguration: ServiceConfig = {
  [UpdateService.Instagram]: {
    enabled: true,
    postTypes: {
      [UpdateType.POST]: {
        remindersEnabled: true,
        reminderFields: [
          PostFields.FIRST_COMMENT,
          PostFields.LOCATION_NAME,
          PostFields.MUSIC,
          PostFields.PRODUCTS,
        ],
        postFields: [
          PostFields.FIRST_COMMENT,
          PostFields.LOCATION_NAME,
          PostFields.LOCATION_ID,
          PostFields.LINK,
          PostFields.COLLABORATORS,
          PostFields.IS_AI_GENERATED,
        ],
      },
      [UpdateType.REELS]: {
        remindersEnabled: true,
        reminderFields: [
          PostFields.MUSIC,
          PostFields.FIRST_COMMENT,
          PostFields.LOCATION_NAME,
          PostFields.TEXT,
          PostFields.TOPICS,
          PostFields.PRODUCTS,
        ],
        postFields: [
          PostFields.FIRST_COMMENT,
          PostFields.LOCATION_NAME,
          PostFields.LOCATION_ID,
          PostFields.LINK,
          PostFields.COLLABORATORS,
          PostFields.TRIAL_REEL_GRADUATION_STRATEGY,
          PostFields.SHARE_TO_FEED,
          PostFields.IS_AI_GENERATED,
        ],
      },
      [UpdateType.STORY]: {
        remindersEnabled: true,
        reminderFields: [
          PostFields.TEXT,
          PostFields.LINK,
          PostFields.MUSIC,
          PostFields.OTHER,
        ],
        postFields: [PostFields.IS_AI_GENERATED],
      },
    },
  },
  [UpdateService.Tiktok]: {
    enabled: true,
    postTypes: {
      [UpdateType.POST]: {
        remindersEnabled: true,
        reminderFields: [],
        postFields: [PostFields.TITLE, PostFields.IS_AI_GENERATED],
      },
    },
  },
  [UpdateService.Youtube]: {
    enabled: true,
    postTypes: {
      [UpdateType.POST]: {
        remindersEnabled: true,
        reminderFields: [],
        postFields: [],
      },
    },
  },
}
